import EmptyStateExamResult from "#/assets/exam-results/EmptyStateGeneralInfo.svg?url";
import styles from "./styles.module.scss";

const EmptyState = () => {
  return (
    <div className={styles["empty-state"]}>
      <img src={EmptyStateExamResult} />
    </div>
  );
};

export default EmptyState;
